import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/imgs/new-client.png'
import _imports_1 from '../assets/imgs/my-clients.png'


const _hoisted_1 = { class: "mt-auto flex items-center justify-center font-lora text-gray-900" }
const _hoisted_2 = { class: "space-y-9 pb-24" }
const _hoisted_3 = { class: "flex flex-wrap gap-6" }

import Button from 'primevue/button';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "text-3xl" }, "Wybierz, co chcesz zrobić", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: `/${_ctx.$route.params.calculatorId}/client/new`
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), { text: "" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "relative flex h-[202px] w-[362px] items-end rounded-[10px] border border-gray-200 bg-white p-6" }, [
                  _createElementVNode("img", {
                    class: "absolute right-0 top-0",
                    src: _imports_0,
                    alt: ""
                  }),
                  _createElementVNode("p", { class: "text-2xl font-medium text-gray-900" }, "Nowy klient")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RouterLink, {
          to: `/${_ctx.$route.params.calculatorId}/clients`
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), { text: "" }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "relative flex h-[202px] w-[362px] items-end rounded-[10px] border border-gray-200 bg-white p-6" }, [
                  _createElementVNode("img", {
                    class: "absolute right-0 top-0",
                    src: _imports_1,
                    alt: ""
                  }),
                  _createElementVNode("p", { class: "text-2xl font-medium text-gray-900" }, "Moi klienci")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_RouterLink, {
          to: `/${_ctx.$route.params.calculatorId}/calculations`
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), { text: "" }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "relative flex h-[202px] w-[362px] items-end rounded-[10px] border border-gray-200 bg-white p-6" }, [
                  _createElementVNode("img", {
                    class: "absolute right-0 top-0",
                    src: _imports_1,
                    alt: ""
                  }),
                  _createElementVNode("p", { class: "text-2xl font-medium text-gray-900" }, "Moje kalkulacje")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})